import globalAxios, { AxiosRequestConfig } from 'axios';
import { getModule } from 'vuex-module-decorators';
import UserInfoStoreModule from './store/modules/userInfo.module';

export function registerAxiosLocaleInterceptor(additionalAxiosInstance) {
    const userInfoModule = getModule(UserInfoStoreModule);

    globalAxios.interceptors.request.use((config: AxiosRequestConfig) => {
        return setLocaleHeaderFromUserInfoModule(config, userInfoModule);
    });

    additionalAxiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
        return setLocaleHeaderFromUserInfoModule(config, userInfoModule);
    });
}

function setLocaleHeaderFromUserInfoModule(config: AxiosRequestConfig, userInfoModule: UserInfoStoreModule) {
    if (userInfoModule.userInfo.catalogIdentifier) {
        config.headers['Accept-Language'] = userInfoModule.userInfo.catalogIdentifier;
    }

    return config;
}
